import { Button, ButtonGroup } from '@mui/material';
import { lisTranscodesService } from 'services/api';
import { GridColumns } from '@mui/x-data-grid-premium';
import { IsTenantAdministrator } from 'components/helpers/IsTenantAdministrator';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import TenantPage from 'components/common/TenantPage';
import { baseCell } from 'components/common/enhanced/cells/base-cell';

export const LISTranscodes = () => {
  const translationPrefix = 'pages.lis-transcodes.list';
  const { t } = useTranslation();

  const columns: GridColumns = [
    {
      field: 'laboratory',
      headerName: t(`global.laboratory`),
      flex: 1,
      renderCell: baseCell
    },
    {
      field: 'transcode',
      headerName: t(`global.transcode`),
      flex: 1,
      renderCell: baseCell
    }
  ];

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}
        menuRight={
          <div className="flex justify-end items-center">
            <ButtonGroup>
              <IsTenantAdministrator>
                <Link to="new">
                  <Button variant="outlined" size="small">
                    <AddIcon />
                    {t(`${translationPrefix}.add`)}
                  </Button>
                </Link>
              </IsTenantAdministrator>
            </ButtonGroup>
          </div>
        }>
        <div className="mt-6">
          <EnhancedDataGrid columns={columns} service={lisTranscodesService} />
        </div>
      </TenantPage>
    </>
  );
};

export default LISTranscodes;
